import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map } from 'rxjs';

import { AgentSkillFacade, ChanEnum, Channel, PlanningFacade, ProfileService, reduceOfArr, UntilDestroy } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'cng-agent-planning',
  templateUrl: 'agent-planning.component.html',
  styleUrls: ['./agent-planning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentPlanningComponent implements OnDestroy {
  readonly plannings$ = this.planningFacade.keys$.pipe(
    map(plannings =>
      plannings.reduce(
        (acc, { channel, skillIds }) => [
          ...acc,
          {
            key: 'channel',
            value: channel,
          },
          ...(skillIds || []).map(id => ({
            key: 'skill',
            value: {
              channel,
              skillId: id,
            },
          })),
        ],
        []
      )
    )
  );

  get index$() {
    return this._index$.pipe(distinctUntilChanged());
  }
  private readonly _index$ = new BehaviorSubject<number>(-1);

  constructor(
    private readonly planningFacade: PlanningFacade,
    private readonly agentSkillFacade: AgentSkillFacade,
    private readonly profileService: ProfileService
  ) {}

  ngOnDestroy() {
    this._index$.complete();
  }

  toogleSkillsActivation(newValue: boolean, channel: Channel): void {
    this.agentSkillFacade.changeAllActivation(channel, newValue);
  }

  toogleSkillActivation(newValue: boolean, skillId: string, channel: Channel): void {
    this.agentSkillFacade.changeActivation(skillId, channel, newValue);
  }

  get hasActivationRight$() {
    return combineLatest([
      this.profileService.hasPermission$('CSR::self:skill_activation'),
      this.profileService.hasPermission$('CSR::self:channel_activation'),
      this.agentSkillFacade.hasSkills(ChanEnum.In.ChatIAdvise),
    ]).pipe(reduceOfArr((result, cur) => result || cur, false));
  }
}
